import { inject } from '@angular/core';
import { Router, type CanMatchFn } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';
import { firstValueFrom } from 'rxjs';

export const authenticationGuard: CanMatchFn = async(route, segments) => {

  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = await firstValueFrom(authService.isLoggedIn());

  if (!isAuthenticated) {
    router.navigateByUrl('auth');
    return false;
  }

  return true;
};
